import { AlertCircle } from 'lucide-react'

interface AlertMessagesProps {
    message?: string
    errors?: string[]
}

export default function AlertMessages({ message, errors }: AlertMessagesProps) {
    return (
        <>
            {message && (
                <div className="mb-6 bg-green-50 border border-green-200 rounded-md p-4">
                    <div className="flex">
                        <div className="ml-3">
                            <p className="text-sm text-green-700">{message}</p>
                        </div>
                    </div>
                </div>
            )}

            {errors && errors.length > 0 && (
                <div className="mb-6 bg-red-50 border border-red-200 rounded-md p-4">
                    <div className="flex">
                        <AlertCircle className="h-5 w-5 text-red-400"/>
                        <div className="ml-3">
                            <h3 className="text-sm font-medium text-red-800">
                                There were errors with your submission:
                            </h3>
                            <ul className="mt-2 text-sm text-red-700 list-disc list-inside">
                                {errors.map((error, index) => (
                                    <li key={index}>{error}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}